<template>
  <div class="modal fade" id="modal-edit-document" ref="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content modal-lg">
        <form enctype="multipart/form-data" ref="form" v-on:submit.prevent="uploadFiles">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>

            <h4 class="modal-title">
              {{ title }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="alert alert-danger" v-if="firstError">{{ firstError }}</div>

            <div class="form-group">
              <label>Document</label>
              <document-list :files="[document]" :sharable="tab !== 'admin'" :removable="false"></document-list>
            </div>
          </div>
          <!-- Modal Actions -->
          <div class="modal-footer text-left">
            <button
                type="button"
                class="btn btn-md btn-primary pull-right"
                @click="uploadFiles"
                :disabled="disabled"
            >
              <span v-if="uploading" class="loading-dots">Bezig met verwerken</span>
              <span v-else>Aanpassen</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentEdit',

  props: {
    title: {
      type: String,
      default: 'Bijlage aanpassen',
    },

    document: {
      type: Object,
      default: null,
    },

    tab: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      errors: {},
      selectedUsers: [],
      uploading: false,
    }
  },
  mounted() {
    this.selectedUsers = this.initSelectedUsers;

    jQuery(this.$refs.modal).modal().on('hidden.bs.modal', () => {
      this.$emit('close');
    });
  },

  computed: {
    disabled() {
      return this.uploading;
    },

    firstError() {
      const key = Object.keys(this.errors)[0];
      if (this.errors[key]) {
        return this.errors[key][0];
      }

      return null;
    }
  },

  methods: {
    uploadFiles() {
      this.uploading = true;

      const name = this.$refs.form.querySelector('input[type=text]').value;
      const shared = this.$refs.form.querySelector('input[type=checkbox]').checked;

      const data = {
        id: this.document.id,
        name: name,
        shared: shared,
      };

      this.$http.patch(`/documenten/${this.document.id}`, data).then((response) => {
        this.$emit('updated', data);
        this.uploading = false;
      }, (response) => {
        this.errors = response.data.errors;
        this.uploading = false;
      });


    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/documents/DocumentEdit.vue